/**
 * Each one of these modules represents a namespace within the Apollo Client's
 * local cache.
 * @deprecated This file is deprecated. Move queries to graphql/operations. See /docs/typedQueries for more information.
 */
export { default as AttendeeConnections } from './AttendeeConnections';
export { default as Discussions } from './Discussions';
export { default as Session } from './Session';
export { default as Sponsor } from './Sponsor';
export { default as User } from './User';
